import { render, staticRenderFns } from "./tableWithChildren.vue?vue&type=template&id=8d310da2"
import script from "./tableWithChildren.vue?vue&type=script&lang=js"
export * from "./tableWithChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports